import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useCreateArea = ({ onError, onSuccess}) => {
    
    const apiUrl = useSelector(apiUrlSelector);
    const queryClient = useQueryClient();

    return useMutation(values => {
        
            if ( parseInt(values.id) > 0 ) {
                return axios.patch(`${apiUrl}areas/${values.id}`, values).then(res => res.data);
            } else {
                return axios.post(`${apiUrl}areas`, values).then(res => res.data)
            }
        },
        {
            onSuccess: () => {
                onSuccess();
                queryClient.invalidateQueries(["areas", apiUrl]);
                queryClient.invalidateQueries(["areas", { is_active: 1 }, apiUrl]);
            }, onError: onError
        }
    );
};

export default useCreateArea;